export const IDCARD_SECTIONS_ENUM = {
  ViewsAndLayouts: 'ViewsAndLayouts',
  WeightBreakdown: 'WeightBreakdown',
  TieIns: 'TieIns',
  EquipmentList: 'EquipmentList',
  DocumentList: 'DocumentList',
  OtherDocumentList: 'OtherDocumentList',
  LocationOnFPSO: 'LocationOnFPSO',
};
